import { addDays } from 'date-fns';

const vipClaimData = {
  id: "1",
  title: "Choose the currency you would like to be paid out in:",
  image: "/img/rewards/reward/2-2.png",
  selectedCurrency: ["USDT"],
  list: [
    {
      id: "USDT",
      name: "Tether (USDT)",
      icon: "/crypto/usd.png"
    },
    {
      id: "ETH",
      name: "Etherium (ETH)",
      icon: "/crypto/ETH.png"
    },
    {
      id: "APL",
      name: "Apollo (APL)",
      icon: "/crypto/APL.png"
    },
    {
      id: "QKC",
      name: "Quarkchein (QKC)",
      icon: "/crypto/QKC.png"
    },
    {
      id: "BTC",
      name: "Bitcoin (BTC)",
      icon: "/crypto/BTC.png"
    },
    {
      id: "NXT",
      name: "Nxt (NXT)",
      icon: "/crypto/NXT.png"
    }
  ],
  total: {
    amount: "95.2",
    currency: "ETH",
    currencyIcon: "/crypto/ETH.png"
  },
  claims: {
    currentLevel: 4,
    maxLevels: 12,
    list: [
      {
        level: 1,
        claimed: true,
        activeAt: addDays(/* @__PURE__ */ new Date(), -10),
        amount: "95.2"
      },
      {
        level: 2,
        claimed: false,
        activeAt: addDays(/* @__PURE__ */ new Date(), -10),
        amount: "95.2"
      },
      {
        level: 3,
        claimed: true,
        activeAt: addDays(/* @__PURE__ */ new Date(), -10),
        amount: "95.2"
      },
      {
        level: 4,
        claimed: false,
        activeAt: addDays(/* @__PURE__ */ new Date(), 0),
        amount: "95.2"
      },
      {
        level: 5,
        claimed: false,
        activeAt: addDays(/* @__PURE__ */ new Date(), 1),
        amount: "95.2"
      },
      {
        level: 6,
        claimed: false,
        activeAt: addDays(/* @__PURE__ */ new Date(), 1),
        amount: "95.2"
      },
      {
        level: 7,
        claimed: false,
        activeAt: addDays(/* @__PURE__ */ new Date(), 1),
        amount: "95.2"
      },
      {
        level: 8,
        claimed: false,
        activeAt: addDays(/* @__PURE__ */ new Date(), 1),
        amount: "95.2"
      },
      {
        level: 9,
        claimed: false,
        activeAt: addDays(/* @__PURE__ */ new Date(), 1),
        amount: "95.2"
      },
      {
        level: 10,
        claimed: false,
        activeAt: addDays(/* @__PURE__ */ new Date(), 1),
        amount: "95.2"
      },
      {
        level: 11,
        claimed: false,
        activeAt: addDays(/* @__PURE__ */ new Date(), 1),
        amount: "95.2"
      },
      {
        level: 12,
        claimed: false,
        activeAt: addDays(/* @__PURE__ */ new Date(), 1),
        amount: "95.2"
      }
    ],
    nextClaimAt: addDays(/* @__PURE__ */ new Date(), 0)
  }
};
const currencyListOpt = [
  {
    id: "USDT",
    name: "Tether (USDT)",
    icon: "/crypto/usd.png"
  },
  {
    id: "ETH",
    name: "Etherium (ETH)",
    icon: "/crypto/ETH.png"
  },
  {
    id: "APL",
    name: "Apollo (APL)",
    icon: "/crypto/APL.png"
  },
  {
    id: "QKC",
    name: "Quarkchein (QKC)",
    icon: "/crypto/QKC.png"
  },
  {
    id: "AEON",
    name: "Aeon (AEON)",
    icon: "/crypto/usd.png"
  },
  {
    id: "NXT",
    name: "Nxt (NXT)",
    icon: "/crypto/NXT.png"
  }
];
const rewardsData = [
  {
    id: "1",
    text: "",
    name: "Instant Rakeback",
    claimed: false,
    enableAt: "",
    isAuth: true,
    image: "/rewards/reward/gift.png",
    type: "pending",
    actionType: "instant_rakeback"
  },
  {
    text: "6 claims left",
    name: "Weekly reload",
    claimed: false,
    enableAt: "",
    isAuth: true,
    image: "/rewards/reward/calendar-1.png",
    type: "remaining",
    actionType: "weekly_reload",
    id: "2"
  },
  {
    text: "6 claims left",
    name: "Monthly reload",
    claimed: false,
    enableAt: "",
    buttonText: "Claim",
    isAuth: true,
    image: "/rewards/reward/calendar-2.png",
    type: "remaining",
    actionType: "monthly_reload",
    id: "3"
  },
  {
    text: "6 claims left",
    name: "VIP reload",
    claimed: false,
    enableAt: addDays(/* @__PURE__ */ new Date(), 0),
    isAuth: true,
    image: "/rewards/reward/vip.png",
    type: "remaining",
    actionType: "vip_reload",
    id: "4",
    details: {
      ...vipClaimData,
      id: "4"
    }
  },
  {
    text: "23 hours left",
    name: "VIP reload",
    claimed: false,
    enableAt: addDays(/* @__PURE__ */ new Date(), 3),
    isAuth: true,
    image: "/rewards/reward/vip.png",
    type: "remaining",
    actionType: "vip_reload",
    id: "5",
    details: {
      ...vipClaimData,
      id: "5"
    }
  }
];
const rewardsDataV2 = [
  {
    id: "1",
    text: "",
    name: "Instant Rakeback",
    claimed: false,
    enableAt: "",
    isAuth: true,
    image: "instant_rakeback",
    type: "pending",
    actionType: "instant_rakeback"
  },
  {
    text: "6 claims left",
    name: "Weekly reload",
    claimed: false,
    enableAt: "",
    isAuth: true,
    image: "week_reload",
    type: "remaining",
    actionType: "weekly_reload",
    id: "2"
  },
  {
    text: "6 claims left",
    name: "Monthly reload",
    claimed: false,
    enableAt: "",
    buttonText: "Claim",
    isAuth: true,
    image: "month_reload",
    type: "remaining",
    actionType: "monthly_reload",
    id: "3"
  },
  {
    text: "6 claims left",
    name: "VIP reload",
    claimed: false,
    enableAt: addDays(/* @__PURE__ */ new Date(), 0),
    isAuth: true,
    image: "vip_reload",
    type: "remaining",
    actionType: "vip_reload",
    id: "4",
    details: {
      ...vipClaimData,
      id: "4"
    }
  },
  {
    text: "23 hours left",
    name: "VIP reload",
    claimed: false,
    enableAt: addDays(/* @__PURE__ */ new Date(), 3),
    isAuth: true,
    image: "vip_reload",
    type: "remaining",
    actionType: "vip_reload",
    id: "5",
    details: {
      ...vipClaimData,
      id: "5"
    }
  }
];
const vipReloadTitles = {
  vip_reload: "Vip reload",
  instant_rakeback: "Instant Rakeback",
  daily_reload: "Daily Reload",
  weekly_reload: "Weekly Reload",
  monthly_reload: "Monthly Reload",
  level_up: "Level Up"
};
const vipLevelData = [
  {
    level: {
      id: "Bronze",
      name: "Bronze",
      isTotalComplete: false,
      progress: [
        {
          value: 100
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        }
      ],
      isAvailable: true
    },
    subLevels: [
      {
        name: "Bronze I",
        isCurrent: false,
        xp: {
          current: 1e4,
          max: 1e4
        }
      },
      {
        name: "Bronze II",
        isCurrent: true,
        xp: {
          current: 4900,
          max: 1e4
        }
      },
      {
        name: "Bronze III",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Bronze IIII",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      }
    ]
  },
  {
    level: {
      id: "Silver",
      name: "Silver",
      isTotalComplete: false,
      isAvailable: true,
      progress: [
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        }
      ]
    },
    subLevels: [
      {
        name: "Silver I",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Silver II",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Silver III",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Silver IIII",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      }
    ]
  },
  {
    level: {
      id: "Gold",
      isAvailable: true,
      isTotalComplete: false,
      name: "Gold",
      progress: [
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        }
      ]
    },
    subLevels: [
      {
        name: "Gold I",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Gold II",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Gold III",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Gold IIII",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      }
    ]
  },
  {
    level: {
      id: "Platinum",
      isAvailable: true,
      isTotalComplete: false,
      name: "Platinum",
      progress: [
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        }
      ]
    },
    subLevels: [
      {
        name: "Platinum I",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Platinum II",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Platinum III",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Platinum IIII",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      }
    ]
  },
  {
    level: {
      id: "Pearl",
      isAvailable: true,
      isTotalComplete: false,
      name: "Pearl",
      progress: [
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        }
      ]
    },
    subLevels: [
      {
        name: "Pearl I",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Pearl II",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Pearl III",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Pearl IIII",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      }
    ]
  },
  {
    level: {
      id: "Onyx",
      isAvailable: true,
      isTotalComplete: false,
      name: "Onyx",
      progress: [
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        }
      ]
    },
    subLevels: [
      {
        name: "Onyx I",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Onyx II",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Onyx III",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Onyx IIII",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      }
    ]
  },
  {
    level: {
      id: "Diamond",
      isAvailable: true,
      isTotalComplete: false,
      name: "Diamond",
      progress: [
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        }
      ]
    },
    subLevels: [
      {
        name: "Diamond I",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Diamond II",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Diamond III",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Diamond IIII",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      }
    ]
  },
  {
    level: {
      id: "Palladium",
      isAvailable: false,
      isTotalComplete: false,
      name: "Palladium",
      progress: [
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        }
      ]
    },
    subLevels: [
      {
        name: "Palladium I",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Palladium II",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Palladium III",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Palladium IIII",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      }
    ]
  },
  {
    level: {
      id: "Castle",
      name: "Castle",
      isTotalComplete: false,
      isAvailable: false,
      progress: [
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        }
      ]
    },
    subLevels: [
      {
        name: "Castle I",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Castle II",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Castle III",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      },
      {
        name: "Castle IIII",
        isCurrent: false,
        xp: {
          current: 0,
          max: 1e4
        }
      }
    ]
  }
];
const instantRakebackData = {
  title: "The redeemed currency will be added to your account",
  image: "/rewards/reward/2-2.png",
  selectedCurrency: ["USDT"],
  list: [
    {
      id: "USDT",
      name: "Tether (USDT)",
      icon: "/crypto/USDT.png"
    },
    {
      id: "ETH",
      name: "Etherium (ETH)",
      icon: "/crypto/ETH.png"
    },
    {
      id: "APL",
      name: "Apollo (APL)",
      icon: "/crypto/APL.png"
    },
    {
      id: "QKC",
      name: "Quarkchein (QKC)",
      icon: "/crypto/QKC.png"
    },
    {
      id: "AEON",
      name: "Aeon (AEON)",
      icon: "/crypto/AEON.png"
    },
    {
      id: "NXT",
      name: "Nxt (NXT)",
      icon: "/crypto/NXT.png"
    }
  ],
  total: {
    amount: "12.0000000",
    currency: "ETH",
    currencyIcon: "/crypto/ETH.png"
  },
  onClick: () => {
  },
  onCurrencyChange: () => {
  }
};
const benefitsData = [
  {
    title: "Rewards Slider",
    description: "Use the Rewards Slider to get instant bonuses",
    icon: "/rewards/benefits/1.png"
  },
  {
    title: "Daily Rakeback",
    description: "Get a portion of your bets refunded every day",
    icon: "/rewards/benefits/2.png"
  },
  {
    title: "Level up bonus",
    description: "Increase your game level and get generous rewards",
    icon: "/rewards/benefits/3.png"
  },
  {
    title: "Bonus weekly",
    description: "Increase your game level and get generous rewards",
    icon: "/rewards/benefits/1.png"
  },
  {
    title: "Rewards Slider",
    description: "Use the Rewards Slider to get instant bonuses"
  }
];
const rewardsStepsBannerData = {
  title: "$10m in USDT available",
  subtitle: "Claim your bespoke bonus now!",
  date: addDays(/* @__PURE__ */ new Date(), 14)
};
const rewardsStepsProgressData = {
  title: "Available",
  currencyImg: "/crypto/ETH.png",
  amount: 20228.76,
  max: 6e4
};
const rainUsers = [
  {
    avatar: "",
    id: "3",
    name: "Fery011",
    info: {
      gamesPlayed: 133,
      wagered: "34",
      profit: "0"
    }
  },
  {
    avatar: "",
    id: "3",
    name: "Johanna2991",
    info: {
      gamesPlayed: 133,
      wagered: "34",
      profit: "0"
    }
  },
  {
    avatar: "",
    id: "3",
    name: "RiskTakerExtreme",
    info: {
      gamesPlayed: 133,
      wagered: "34",
      profit: "0"
    }
  }
];

export { benefitsData, currencyListOpt, instantRakebackData, rainUsers, rewardsData, rewardsDataV2, rewardsStepsBannerData, rewardsStepsProgressData, vipClaimData, vipLevelData, vipReloadTitles };
//# sourceMappingURL=index.js.map
